/* ANB 5d: helpers (idle, passive, observer gates) */
window.ANB = window.ANB || {};
(function(){
  ANB.idle = function(cb){ if ('requestIdleCallback' in window) { requestIdleCallback(cb, {timeout:1500}); } else { setTimeout(cb,0); } };
  ANB.passiveOn = function(el, evt, fn){ try{ el.addEventListener(evt, fn, {passive:true}); }catch(e){ el.addEventListener(evt, fn, false); } };
  ANB.deferWhenVisible = function(selector, mount){
    try {
      var target = document.querySelector(selector);
      if (!target) return;
      if (!('IntersectionObserver' in window)) { mount(); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) { try{ mount(); }catch(err){} io.unobserve(e.target); }
        });
      });
      io.observe(target);
    } catch(e) {}
  };
  // passive defaults
  ANB.idle(function(){
    ANB.passiveOn(window, 'touchstart', function(){});
    ANB.passiveOn(window, 'wheel', function(){});
  });
})();

/* tiny DOM safety helpers */
ANB.q = function(sel){ try { return document.querySelector(sel); } catch(e){ return null; } };
ANB.on = function(el, evt, fn, opts){ if(el && el.addEventListener){ el.addEventListener(evt, fn, opts||false); } };

ANB.setText = function(el, v){ if(el){ el.textContent = (v==null?'': String(v)); } };
